import { Component, Input } from '@angular/core';
import { ApplicationActions } from '../../actions/application.actions';
import { NgRedux } from '@angular-redux/store';
import * as _ from 'lodash';

@Component({
  selector: 'md-file-attachments',
  template: require('./file-attachments.component.html'),
  styles: [require('./file-attachments.component.scss')]
})

export class FileAttachmentsComponent {

  @Input() summary;
  fileList = [];
  state;

  constructor(appActions: ApplicationActions, ngRedux: NgRedux) {
    this.appActions = appActions;
    this.ngRedux = ngRedux;
  }

  ngOnInit() {
    if (this.summary.path) {
      this.reduxObservable$ = this.ngRedux.select(state => _.get(state, `applicationStore.${this.summary.path}`));
      this.reduxSubscription = this.reduxObservable$.subscribe(state => {
        this.state = state;
        // Convert state to list
        this.fileList = state ? Object.keys(state).map(e => state[e]) : [];
      });
    }
  }

  ngOnDestroy() {
    if (this.validateSub) {
      this.validateSub.unsubscribe();
    }

    if (this.summary.path) {
      this.reduxObservable$.unsubscribe();
      this.reduxSubscription.unsubscribe();
    }
  }

  remove(item) {
    delete this.state[item.path.split('.').pop()];
    if (item.path) {
      this.appActions.setData(this.summary.path, this.state);
    }
  }
}
